// extracted by mini-css-extract-plugin
export default {"base":"base_base__vJEYP"};